const stepCurrent = window.btoa(`
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#000914"/>
  </svg>
`)

const stepCurrentSelected = window.btoa(`
  <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23" cy="23" r="23" fill="#000914" fill-opacity="0.3"/>
    <circle cx="23" cy="23" r="15" fill="#000914"/>
  </svg>
`)

const stepInactive = window.btoa(`
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#666B72"/>
  </svg>
`)

const stepInactiveSelected = window.btoa(`
  <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23" cy="23" r="23" fill="#666B72" fill-opacity="0.3"/>
    <circle cx="23" cy="23" r="15" fill="#666B72"/>
  </svg>
`)

const stepComing = window.btoa(`
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#000914"/>
  </svg>
`)

const stepComingSelected = window.btoa(`
  <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23" cy="23" r="23" fill="#000914" fill-opacity="0.3"/>
    <circle cx="23" cy="23" r="15" fill="#000914"/>
  </svg>
`)

export const clusterPath = window.btoa(`
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#000914"/>
  </svg>
`)

export const shipClusterPath = window.btoa(`
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#107F8F"/>
  </svg>
`)

export const cruisePaths = {
  A_VENIR: stepComing,
  EN_COURS: stepCurrent,
  PASSE: stepInactive,
  SELECTED: {
    A_VENIR: stepComingSelected,
    EN_COURS: stepCurrentSelected,
    PASSE: stepInactiveSelected,
  },
}
